import React from "react";
import { observer } from "mobx-react-lite";
import { Col, Row } from "react-bootstrap";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import PayGateToTransferRefundDetailViewModel from "../../../../viewModels/finance/refundApprovals/payGateToTransferRefunds/payGateToTransferRefundDetailViewModel";
import PayGateRefundPaymentSectionView from "../detail/payGateRefundPaymentSectionView";
import OrderSectionView from "../detail/orderSectionView";
import RefundPaymentSectionView from "../detail/refundPaymentSectionView";
import RefundDetailView from "../refundDetailView";

const PayGateToTransferRefundDetailView: ViewComponent<PayGateToTransferRefundDetailViewModel> = observer(({ vm }) => {
  return (
    <RefundDetailView vm={vm}>
      <Row className="mb-4">
        <Col>
          <OrderSectionView vm={vm} />
        </Col>
      </Row>
      <Row>
        <Col lg={12} xl={6} className="mb-4 mb-lg-0">
          <PayGateRefundPaymentSectionView vm={vm} />
        </Col>
        <Col lg={12} xl={6}>
          <RefundPaymentSectionView vm={vm} />
        </Col>
      </Row>
    </RefundDetailView>
  );
});

registerView(PayGateToTransferRefundDetailView, PayGateToTransferRefundDetailViewModel);
